import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

export interface RecentConversion {
  id: string;
  eventType: string;
  amount: number;
  currency: string;
  createdAt: string;
  videoId: string | null;
  videoTitle: string | null;
  platformName: string | null;
  platformLogo: string | null;
}

export interface RevenueSummary {
  totalRevenue: number;
  dailyRevenue: number;
  isConnected: boolean;
  hasLinkedVSL: boolean;
}

interface RevenueNotificationsResponse {
  success: boolean;
  data: {
    summary: RevenueSummary;
    recentConversions: RecentConversion[];
  };
}

export function useRevenueSummary() {
  const { data, isLoading } = useQuery<RevenueNotificationsResponse>({
    queryKey: ['revenue-notifications'],
    queryFn: () => api.get<RevenueNotificationsResponse>('/videos/notifications/revenue'),
    staleTime: 2 * 60 * 1000, // 2 minutos
    refetchInterval: 5 * 60 * 1000, // revalida a cada 5 minutos
  });

  return {
    summary: data?.data?.summary ?? {
      totalRevenue: 0,
      dailyRevenue: 0,
      isConnected: false,
      hasLinkedVSL: false,
    },
    recentConversions: data?.data?.recentConversions ?? [],
    isLoading,
  };
}
